import React from 'react';

interface MeasurementLinkProps {
    measurementId: number;
    measurementLabel: string;
    areaId?: number | null;
    onClick?: (measurementId: number, areaId?: number | null) => void;
    style?: React.CSSProperties;
}

/**
 * Reusable component for rendering measurement codes as clickable links
 * When clicked, navigates to a report template filtered by measurement + area type
 */
export const MeasurementLink: React.FC<MeasurementLinkProps> = ({
    measurementId,
    measurementLabel,
    areaId,
    onClick,
    style,
}) => {
    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        if (onClick) {
            onClick(measurementId, areaId ?? null);
        }
    };

    return (
        <a
            href="#"
            onClick={handleClick}
            style={{
                color: '#13c2c2',
                textDecoration: 'none',
                cursor: 'pointer',
                fontWeight: 500,
                ...style,
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.textDecoration = 'underline';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.textDecoration = 'none';
            }}
            title={`View report for ${measurementLabel}`}
        >
            {measurementLabel}
        </a>
    );
};

export default MeasurementLink;
